import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class OrderProcessorSearchModel extends SearchModel<any> {
    static readonly CAPABILITY_FILTER_NAME: string = "capability";

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "id";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}

